var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useApi from '@/hoc/hooks/useApi';
import React, { useEffect, useMemo, useState } from 'react';
import GenericModal from '../generic-modal';
import { ArrowUpIcon, PlusIcon } from '../icons';
import ManageCustomization from '../manage-customization';
var FlowDropdown = function (props) {
    // Props
    var label = props.label, placeholder = props.placeholder, callback = props.callback;
    // States
    var _a = useState(false), isExpanded = _a[0], setIsExpanded = _a[1];
    var _b = useState(false), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var _c = useState([]), defaultFlows = _c[0], setDefaultFlows = _c[1];
    var _d = useState([]), nonDefaultFlows = _d[0], setNonDefaultFlows = _d[1];
    var _e = useState(null), selectedFlow = _e[0], setSelectedFlow = _e[1];
    // API call
    var _f = useApi('/flow?include_default=true'), flows = _f.data, error = _f.error, loading = _f.loading, fetchData = _f.fetchData;
    var jobId = useMemo(function () {
        var urlParams = new URLSearchParams(window.location.search);
        var jobId = urlParams.get('id');
        return jobId;
    }, []);
    var _g = useApi("/candidate/associated_flow?jobId=".concat(jobId)), associatedFlows = _g.data, fetchAssociatedFlow = _g.fetchData;
    useEffect(function () {
        fetchData();
        fetchAssociatedFlow();
    }, [fetchData, fetchAssociatedFlow]);
    // useEffect(() => {
    //   if (flows?.length) {
    //     const defaultFlows: Flow[] =
    //       flows
    //         ?.filter((flow: Flow) => flow.isDefault)
    //         ?.map((item: Flow) => ({
    //           _id: item._id,
    //           name: item.name,
    //           description: item.description,
    //           isDefault: item.isDefault,
    //           stages: item.stages,
    //           stageId: item.stages.length,
    //         })) || [];
    //     const nonDefaultFlows: Flow[] =
    //       flows
    //         ?.filter((flow: Flow) => !flow.isDefault)
    //         ?.map((item: Flow) => ({
    //           _id: item._id,
    //           name: item.name,
    //           description: item.description,
    //           isDefault: item.isDefault,
    //           stages: item.stages,
    //           stageId: item.stages.length,
    //         })) || [];
    //     setNonDefaultFlows(nonDefaultFlows);
    //     setDefaultFlows(defaultFlows);
    //     if (!selectedFlow || associatedFlows?.data.length) {
    //       const selectedFlow = associatedFlows?.data?.[0];
    //       setSelectedFlow({
    //         id: selectedFlow?._id || defaultFlows[0]?._id || '',
    //         name: selectedFlow?.name || defaultFlows[0]?.name || placeholder,
    //       });
    //       callback?.(defaultFlows[0]?._id || '');
    //     }
    //   }
    // }, [flows, selectedFlow, placeholder, callback, associatedFlows]);
    // Handle flow selection
    useEffect(function () {
        var _a, _b, _c, _d;
        if (flows === null || flows === void 0 ? void 0 : flows.length) {
            var defaultFlows_1 = flows
                .filter(function (flow) { return flow.isDefault; })
                .map(function (item) { return (__assign(__assign({}, item), { stageId: item.stages.length })); });
            var nonDefaultFlows_1 = flows
                .filter(function (flow) { return !flow.isDefault; })
                .map(function (item) { return (__assign(__assign({}, item), { stageId: item.stages.length })); });
            setDefaultFlows(defaultFlows_1);
            setNonDefaultFlows(nonDefaultFlows_1);
            // Set selectedFlow only if it's null
            if (!selectedFlow) {
                var assoc = (_a = associatedFlows === null || associatedFlows === void 0 ? void 0 : associatedFlows.data) === null || _a === void 0 ? void 0 : _a[0];
                var newSelectedFlow = {
                    id: (assoc === null || assoc === void 0 ? void 0 : assoc._id) || ((_b = defaultFlows_1[0]) === null || _b === void 0 ? void 0 : _b._id) || '',
                    name: (assoc === null || assoc === void 0 ? void 0 : assoc.name) || ((_c = defaultFlows_1[0]) === null || _c === void 0 ? void 0 : _c.name) || placeholder,
                    stages: (assoc === null || assoc === void 0 ? void 0 : assoc.stages) || ((_d = defaultFlows_1[0]) === null || _d === void 0 ? void 0 : _d.stages) || [],
                };
                setSelectedFlow(newSelectedFlow);
                callback === null || callback === void 0 ? void 0 : callback(newSelectedFlow.id);
            }
        }
    }, [flows, associatedFlows, placeholder, callback]); // 🚫 removed `selectedFlow` from here
    var handleFlowSelect = function (id, name) {
        setSelectedFlow({
            id: id,
            name: name,
        });
        setIsExpanded(false);
        if (callback) {
            callback(id);
        }
    };
    // Close dropdown when clicking outside
    useEffect(function () {
        var handleClickOutside = function (event) {
            var target = event.target;
            if (isExpanded && !target.closest('.dropdown-container')) {
                setIsExpanded(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isExpanded]);
    return (_jsxs("div", { className: 'flex flex-col gap-1 relative dropdown-container', children: [_jsx("p", { className: 'w-full text-typographyLabelsFontSize text-typographyLabelsTextColor font-typographyLabelsFontWeight', children: label }), _jsxs("div", { className: 'min-h-10 rounded-[10px] px-[10px] py-2 bg-vjwSecondary flex justify-between items-center cursor-pointer', onClick: function () { return setIsExpanded(!isExpanded); }, children: [_jsx("span", { className: 'text-typographySubHeadingTextColor', children: (selectedFlow === null || selectedFlow === void 0 ? void 0 : selectedFlow.name) || placeholder }), _jsx("button", { className: 'rounded-md transition-transform duration-300 cursor-pointer', "aria-label": isExpanded ? 'Collapse dropdown' : 'Expand dropdown', type: 'button', children: _jsx("div", { className: "transform ".concat(isExpanded ? 'rotate-0' : 'rotate-180'), children: _jsx(ArrowUpIcon, {}) }) })] }), isExpanded && (_jsxs("div", { className: 'absolute top-full left-0 mt-1 w-full shadow-lg rounded-md bg-white z-10 overflow-visible', children: [defaultFlows.map(function (flow) {
                        var _a;
                        return (_jsxs("div", { className: 'relative group inline-block p-2 cursor-pointer', onClick: function () { return handleFlowSelect(flow._id, flow.name); }, children: [_jsx("span", { className: 'text-typographySubheadingFontSize text-typographySubHeadingTextColor', children: flow.name }), _jsxs("div", { className: 'pointer-events-none absolute top-1/2 left-full ml-2 -translate-y-1/2 z-50 hidden group-hover:block rounded border border-blue-500 bg-white px-3 py-2 text-xs text-black shadow w-64 ', children: [_jsx("ol", { className: 'list-decimal list-inside space-y-1', children: (_a = flow.stages) === null || _a === void 0 ? void 0 : _a.map(function (item, i) { return _jsx("li", { children: item === null || item === void 0 ? void 0 : item.name }, i); }) }), _jsx("div", { className: 'absolute top-1/2 left-0 -translate-x-1/2 -translate-y-1/2 h-2 w-2 rotate-45 bg-white border border-blue-500' })] })] }, flow._id));
                    }), _jsxs("div", { className: 'flex items-center p-2 border-b border-vjwSecondary cursor-pointer hover:bg-vjwSecondary/5', onClick: function (e) {
                            e.stopPropagation();
                            setIsModalOpen(true);
                        }, children: [_jsx("div", { className: 'w-8 h-8 bg-vjwPrimary/10 rounded-md flex items-center justify-center mr-4', children: _jsx(PlusIcon, { fillColor: 'var(--color-primary)' }) }), _jsx("span", { className: 'text-typographySubheadingFontSize text-typographySubHeadingTextColor', children: "Manage Customization" })] }), loading ? (_jsx("div", { className: 'p-2 border-b border-vjwSecondary text-center text-typographyLabelsTextColor', children: "Loading flows..." })) : error ? (_jsx("div", { className: 'p-2 border-b border-vjwSecondary text-center text-vjwDanger', children: "Error loading flows" })) : (nonDefaultFlows.map(function (flow) {
                        var _a;
                        return (_jsx("div", { className: 'p-2 border-b border-vjwSecondary cursor-pointer hover:bg-vjwSecondary/5', onClick: function () { return handleFlowSelect(flow._id, flow.name); }, children: _jsxs("div", { className: 'relative group inline-block', children: [_jsx("span", { className: 'text-typographySubheadingFontSize text-typographySubHeadingTextColor', children: flow.name }), _jsxs("div", { className: 'pointer-events-none absolute top-1/2 left-full ml-2 -translate-y-1/2 z-50 hidden group-hover:block rounded border border-blue-500 bg-white px-3 py-2 text-xs text-black shadow w-64 ', children: [_jsx("ol", { className: 'list-decimal list-inside space-y-1', children: (_a = flow.stages) === null || _a === void 0 ? void 0 : _a.map(function (item, i) { return _jsx("li", { children: item === null || item === void 0 ? void 0 : item.name }, i); }) }), _jsx("div", { className: 'absolute top-1/2 left-0 -translate-x-1/2 -translate-y-1/2 h-2 w-2 rotate-45 bg-white border border-blue-500' })] })] }) }, flow._id));
                    }))] })), _jsx(GenericModal, { isOpen: isModalOpen, onClose: function () {
                    fetchData();
                    setIsModalOpen(false);
                }, children: _jsx(ManageCustomization, { showBackButton: true, className: 'py-0 px-0', headingClassName: 'pr-6' }) })] }));
};
export default FlowDropdown;
